import { useState, useEffect, useCallback } from 'react'
import { partyApi } from '../lib/api'

interface QRCodeDisplayProps {
  partyId: string
  size?: number
}

export default function QRCodeDisplay({ partyId, size = 300 }: QRCodeDisplayProps) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [attempt, setAttempt] = useState(0)

  const retry = useCallback(() => {
    setLoading(true)
    setError(null)
    setAttempt((n) => n + 1)
  }, [])

  useEffect(() => {
    let cancelled = false
    let url: string | null = null

    partyApi.getQR(partyId, size)
      .then((blobUrl) => {
        if (!cancelled) {
          url = blobUrl
          setObjectUrl(blobUrl)
          setLoading(false)
        } else {
          URL.revokeObjectURL(blobUrl)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message)
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
      if (url) URL.revokeObjectURL(url)
    }
  }, [partyId, size, attempt])

  if (loading) {
    return (
      <div className="flex items-center justify-center" style={{ width: size, height: size }}>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center">
        <p className="text-sm text-red-600">Failed to load QR code</p>
        <button type="button" onClick={retry} className="mt-2 text-sm text-brand-600 hover:text-brand-700 font-medium">
          Retry
        </button>
      </div>
    )
  }

  return (
    <img
      src={objectUrl!}
      alt="Party QR Code"
      width={size}
      height={size}
      className="rounded-lg"
    />
  )
}
